import type { AdjustPreviewFormProps } from './types'

export const initialFormValues: AdjustPreviewFormProps = {
  period: '',
  dateCompetence: '',
  week: '',
  accounts: [
    {
      account: '',
      week: '',
      adjustmentValue: '',
      observations: ''
    }
  ]
}
